skrilla.directive('userBetLimits',function() {
    return {
        templateUrl: 'directives/userBetLimits/userBetLimits.html',
        scope: {
            userId: "="
        },
        controller: function($scope, searchService, modalService, currencyService){

            $scope.editing = false;

            $scope.save = function(){
                $scope.limit.isDefault === true ? takeOffDefault() : updateLimit();
            }

            $scope.returnToDefault = function(){
                modalService.confirm("Are you sure you'd like to return this user to default?", function() {
                    searchService.put("limits/bets/" + $scope.userId + "/default", null, "User Bet Limit Successfully updated!").then(function (response) {
                        getLimit();
                    });
                });
            }

            function takeOffDefault(){
                modalService.confirm("Are you sure you'd like to take this user off default Bet limits and update values?",function() {
                    multiplyAmounts();
                    searchService.post("limits/bets/" + $scope.userId, $scope.limit, "User Bet Limit Successfully updated!").then(function (response) {
                        getLimit();
                    });
                });
            }

            function updateLimit(){
                modalService.confirm("Are you sure you'd like to update this users Bet limit values?", function() {
                    multiplyAmounts();
                    searchService.put("limits/bets/" + $scope.userId, $scope.limit, "User Bet Limit Successfully updated!").then(function (response) {
                        divideAmounts();
                    });
                });
            }

            function getLimit() {
                searchService.get("limits/bets/" + $scope.userId).then(function (response) {
                    $scope.limit = response.data;
                    divideAmounts();
                });
            }
            getLimit();

            $scope.isDisabled = function(){
                var disabled = true;
                if($scope.limit){
                    disabled = $scope.limit.isDefault === true && $scope.editing === false;
                }
                return disabled;
            }

            function multiplyAmounts(){
                $scope.limit.maximumStake = currencyService.multiply($scope.limit.maximumStake, $scope.limit.currency);
                $scope.limit.maximumDailyStake = currencyService.multiply($scope.limit.maximumDailyStake, $scope.limit.currency);
                $scope.limit.maximumLiability = currencyService.multiply($scope.limit.maximumLiability, $scope.limit.currency);
            }

            function divideAmounts (){
                $scope.limit.maximumStake = currencyService.divide($scope.limit.maximumStake, $scope.limit.currency);
                $scope.limit.maximumDailyStake = currencyService.divide($scope.limit.maximumDailyStake, $scope.limit.currency);
                $scope.limit.maximumLiability = currencyService.divide($scope.limit.maximumLiability, $scope.limit.currency);
            }

        }
    };
});
